import { Layers, Scale, Anchor, Gauge, TrendingUp } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SectionShell, SectionHead, FeatureCard } from "@/components/site/Primitives";

const DISTINCTIONS = [
  { icon: Layers, tint: "blue", title: "Sits Above the Existing Stack", copy: "NATSU connects ERP, maritime, legal, financial, market and operational systems rather than replacing them." },
  { icon: Scale, tint: "gold", title: "Commercial and Financial Reasoning", copy: "It is designed to evaluate commercial exposure, profitability, obligations, risk, trade-offs and possible outcomes." },
  { icon: Anchor, tint: "blue", title: "Purpose-Built Maritime Knowledge", copy: "Maritime concepts, commercial relationships, charter-party structures and industry logic shape the intelligence." },
  { icon: Gauge, tint: "gold", title: "Executive Decision Experience", copy: "The product prioritises decisions, evidence, scenarios and approvals—not only dashboards and reports." },
  { icon: TrendingUp, tint: "purple", title: "Intelligence That Compounds", copy: "Approved outcomes and customer-specific context can strengthen future recommendations over time." },
];

export function WhyNatsu() {
  return (
    <SectionShell id="why-natsu" tone="white">
      <div className="max-w-3xl">
        <SectionHead
          label="Why NATSU"
          labelColor="blue"
          title="Beyond systems of record. Beyond point intelligence."
        />
      </div>

      <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {DISTINCTIONS.map((d, i) => (
          <Reveal key={d.title} delay={(i % 3) * 0.07}>
            <FeatureCard icon={d.icon} tint={d.tint} title={d.title}>
              {d.copy}
            </FeatureCard>
          </Reveal>
        ))}
        {/* Closing statement occupying the sixth grid cell on large screens */}
        <Reveal delay={0.14}>
          <div className="flex h-full flex-col justify-center rounded-2xl border border-natsu-navy/10 bg-natsu-navy p-7 on-dark">
            <p className="font-display text-lg leading-relaxed text-natsu-warm-white sm:text-xl">
              Traditional platforms store or display information. AI-enabled
              platforms optimise a function.{" "}
              <span className="text-natsu-gold">NATSU Intelligence</span> reasons
              across commercial, operational, contractual, market and external
              signals to support enterprise-level decisions.
            </p>
          </div>
        </Reveal>
      </div>
    </SectionShell>
  );
}
